<div id="page">
  @if(showNavigationBar){
  <admin-navbar id="nc3navigation"></admin-navbar>
  }
  <div class="container-fluid no-padding">
    <admin-flash-message></admin-flash-message>
    <admin-error></admin-error>
    <div class="admin-container" [ngClass]="clazz">
      <div class="content-main">
        <router-outlet></router-outlet>
      </div>
    </div>

  </div>
  <div id="spinner" loading-widget class="admin-loading-widget">
    <img alt="" src="./assets/images/nordic-cool/spinners/spinner_64x64_light.gif" />
  </div>
  <footer>
    <img src="./assets/images/nordic-cool/visma-logo.svg" alt="" width="100" height="21">
  </footer>
</div>